// export const base_uri = "https://solar-backend.onrender.com";
export const base_uri = "https://solar-outlet-next-app.uc.r.appspot.com";
// export const base_uri = "http://127.0.0.1:5001";

export const client_uri = "http://127.0.0.1:3000";
